import _ from 'lodash'
import constants from 'scoreboard/components/constants'
import config from 'scoreboard/components/config'

/**
 * The order the permissions appear on Admin > Groups. If a new permission is
 * added, the easiest way to update this will be to go to Admin > Groups and
 * go to a group with all permissions checked. Then run this in the dev console:
 *
 * lodash.map(jQuery('[type=checkbox][value]'), el => jQuery(el).attr('value'))
 */
const permissionIdsOrder = [0, 17, 53, 1, 10, 14, 64, 24, 73, 74, 33, 48, 43, 49, 60, 69, 70, 71, 76, 72, 4, 5, 50, 51, 57, 3, 42, 55, 56, 75, 66, 8, 67, 68, 65, 25, 54, 6, 52]

/**
 * A map of permission IDs to the order they should appear in a list of
 * permissions in order to match the order the permissions appear on Admin >
 * Groups & Permissions
 */
const permissionIdsOrderMap = {}
_.each(permissionIdsOrder, (permissionId, index) => {
	permissionIdsOrderMap[permissionId] = index
})
_.keyBy(permissionIdsOrder, id => id)

/**
 * A map of permission IDs to the resource bundle keys that describe the
 * permission.
 *
 * The function is memoized so that the config and constants are loaded
 */
const permissionLabels = _.memoize(() => {
	// #30037 use "dashboards and strategy maps" if strategy maps are enabled
	let modifyDashboards = 'admin.group.abilities.modifyDashboards'
	let modifySharedDashboards = 'admin.group.abilities.modifyEmbeddedDashboards'
	if (config.displayStrategyMaps) {
		modifyDashboards += '.strategyMaps'
		modifySharedDashboards += '.strategyMaps'
	}

	let theLabels = {
		[constants.SEC_CODE_VIEWALLORGNODES]: 'admin.group.abilities.viewAllOrgNodes',
		[constants.SEC_CODE_UPDATEALLMETRICS]: 'admin.group.abilities.updateAllMetrics',
		[constants.SEC_CODE_NOTESMODIFY]: 'admin.group.abilities.notesModify',
		[constants.SEC_CODE_STRUCTUREMODIFY]: 'admin.group.abilities.structureModify',
		[constants.SEC_CODE_OWNERUPDATERMODIFY]: 'admin.group.abilities.ownerUpdaterModify',
		[constants.SEC_CODE_APPLICATIONCONFIGURE]: 'admin.group.abilities.applicationConfigure',
		[constants.SEC_CODE_PERMISSIONSMODIFY]: 'admin.group.abilities.permissionsModify',
		[constants.SEC_CODE_UPDATEALLTHRESHOLDS]: 'admin.group.abilities.updateAllThresholds',
		[constants.SEC_CODE_EDITTASKS]: 'admin.group.abilities.editTasks',
		[constants.SEC_CODE_CHANGEHOMEPAGE]: 'admin.group.abilities.changeHomePage',
		[constants.SEC_CODE_ARCHIVETASKS]: 'admin.group.abilities.archiveTasks',
		[constants.SEC_CODE_CALENDARSMODIFY]: 'admin.group.abilities.calendarsModify',
		[constants.SEC_CODE_MODIFYMANAGEDDOCUMENTS]: 'admin.group.abilities.modifyDocuments',
		[constants.SEC_CODE_MODIFYRELATEDITEMS]: 'admin.group.abilities.modifyRelatedItems',
		[constants.SEC_CODE_SQL_CONSOLE_READONLY]: 'admin.consoles.sqlConsoleReadOnly',
		[constants.SEC_CODE_MODIFYREPORTS]: 'admin.group.abilities.modifyChartsAndReports',
		[constants.SEC_CODE_MODIFYBRIEFINGBOOKS]: 'admin.group.abilities.modifyBriefingBooks',
		[constants.SEC_CODE_MODIFYSCORECARDOVERVIEW]: 'admin.group.abilities.modifyScorecardOverview',
		[constants.SEC_CODE_MODIFYDASHBOARDS]: modifyDashboards,
		[constants.SEC_CODE_SERVERCONFIGURE]: 'admin.group.abilities.serverConfigure',
		[constants.SEC_CODE_CHANGE_PASSWORD]: 'admin.group.abilities.changePassword',
		[constants.SEC_CODE_ADMINALLGROUPS]: 'admin.group.abilities.adminAllGroups',
		[constants.SEC_CODE_MODIFYUSERS]: 'admin.group.abilities.modifyUsers',
		[constants.SEC_CODE_DELETEUSERS]: 'admin.group.abilities.deleteUsers',
		[constants.SEC_CODE_MODIFYEMBEDDEDDASHBOARDS]: modifySharedDashboards,
		[constants.SEC_CODE_MODIFYALLDATASETS]: 'datasets.permissions.administer',
		[constants.SEC_CODE_UPDATE_TASK_STATUS]: 'admin.group.abilities.updateTaskStatus',
		[constants.SEC_CODE_MODIFYIMPORTCONNECTIONS]: 'admin.group.abilities.modifyImportConnections',
		[constants.SEC_CODE_MODIFYPROJECTS]: 'admin.group.abilities.modifyProjects',
		[constants.SEC_CODE_MODIFYSCHEDULEDEXPORTS]: 'admin.group.abilities.modifyScheduledExports',
		[constants.SEC_CODE_MODIFYALLIMPORTS]: 'admin.group.abilities.modifyAllImports',
		[constants.SEC_CODE_MODIFYSTANDARDPERMISSIONDATASETS]: 'admin.group.abilities.modifyStandardPermissionDatasets',
		[constants.SEC_CODE_MODIFYDATASETRECORDS]: 'admin.group.abilities.modifyDatasetRecords',
		[constants.SEC_CODE_VIEWDATASETRECORDS]: 'admin.group.abilities.viewDatasetRecords',
		[constants.SEC_CODE_MODIFYDATASETVIEWS]: 'admin.group.abilities.modifyDatasetViews',
		[constants.SEC_CODE_MODIFYFORMS]: 'admin.group.abilities.modifyForms',
		[constants.SEC_CODE_MODIFYEMBEDDEDFORMS]: 'admin.group.abilities.modifyEmbeddedForms',
		[constants.SEC_CODE_IMPERSONATE]: 'admin.group.abilities.impersonate',
		[constants.SEC_CODE_VIEWDATASETRECORDSTAB]: 'admin.group.abilities.viewDatasetRecordsTab'
	}

	return theLabels
})

export { permissionIdsOrderMap, permissionLabels, permissionIdsOrder }
